import { useContext } from "react";
import MilaContext from "./MilaContext";

export function useMilaContext() {
  const context = useContext(MilaContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}